/**
 * Sanitizes name strings for EHR systems while preserving accents and non-Latin scripts.
 * Handles common cases like smart quotes/apostrophes (e.g., O'Connor's → O'Connor's)
 * and removes emojis, symbols, and control characters.
 *
 * @param name - The name string to sanitize
 * @returns Sanitized name preserving Unicode letters, accents, and non-Latin scripts
 *
 * @example
 * sanitizeNameForEHR("O'Connor's") // Returns "O'Connor's"
 * sanitizeNameForEHR("José") // Returns "José"
 * sanitizeNameForEHR("李雷") // Returns "李雷"
 * sanitizeNameForEHR("Мария") // Returns "Мария"
 * sanitizeNameForEHR("Smith-Jones") // Returns "Smith-Jones"
 */
export function sanitizeNameForEHR(name?: string): string {
  if (!name) return "";

  return (
    name
      .trim()
      // Replace smart/curly quotes and apostrophes with straight equivalents
      .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
      .replace(/[\u201C\u201D\u201D\u201E\u201F]/g, '"')
      // Remove emojis, symbols, and non-printable characters
      // Keep: letters (all scripts), numbers, spaces, hyphens, apostrophes, periods, quotes
      .replace(/[^\p{L}\p{N}\s\-'".]/gu, "")
      // Collapse multiple spaces into single space
      .replace(/\s+/g, " ")
      .trim()
  );
}
